import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { LamsaProvider } from './context/LamsaContext'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LamsaProvider>
        <App />
      </LamsaProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
